import * as openpgp from 'openpgp';
import getStore from '../store'



const patientFields = ['firstName', 'lastName', 'addressStreet', 'addressZip', 'addressCountry', 'addressCity', 'addressNumber', 'mobile', 'phone', 'fax', 'email'];
const consultationFields = ['firstName', 'lastName'];


export function encodePatient(patient) {
	const promises = patientFields.map(x => encode(patient[x]));
	return Promise.all(promises).then((res) => {
		res.forEach((value, index) => patient[patientFields[index]] = value)
		return patient
	})
}

export function decodePatient(patient) {
	const promises = patientFields.map(x => decode(patient[x]));
	return Promise.all(promises).then((res) => {
		res.forEach((value, index) => patient[patientFields[index]] = value)
		return patient
	})
}

export function decodeConsultation(consultation) {
	const promises = consultationFields.map(x => decode(consultation[x]));
	return Promise.all(promises).then((res) => {
		res.forEach((value, index) => consultation[consultationFields[index]] = value)
		return consultation
	})
}

const encode = (string) => {
	return new Promise((resolve, reject) => {
		if (!string || !string.trim()) {
			resolve(null);
		}
		const options = {
			data: string,
			passwords: [getStore().getState().session.key],
			armor: false
		}
		openpgp.encrypt(options).then(function(ciphertext) {
			resolve(btoa(String.fromCharCode.apply(null, ciphertext.message.packets.write())))
		}).catch((err) => {
			reject(err)
		})
	})
}

const decode = (string) => {
	return new Promise((resolve, reject) => {
		if (!string || !string.trim()) {
			resolve(null);
		}
		try {
			const encrypted = Uint8Array.from(atob(string), (x) => x.charCodeAt(0))
			const options = {
				message: openpgp.message.read(encrypted),
				passwords: [getStore().getState().session.key],
				format: 'utf8'
			}
			openpgp.decrypt(options).then(function(plaintext) {
				resolve(plaintext.data)
			}).catch((err) => {
				resolve("???")
			})
		} catch(err) {
			resolve("???")
		}
	})
}


// WEBPACK FOOTER //
// ./src/services/encodingService.js